import { CheckCircleOutlined, ExclamationCircleOutlined, LoadingOutlined, WarningOutlined } from "@ant-design/icons";
import { Space } from "antd";
import { CardTitleCsvImport, CardTitleCsvImportStatus, CardTitleCsvImportStatusNames } from "models/cardIngestion";
import { useEffect, useState } from "react";
import useCardTitleCsvImport from "./useCardTitleCsvImport";

const CurrentCardTitleCsvImportStatus = (
    { onCsvImportFinished }: { onCsvImportFinished: (rec: CardTitleCsvImport) => Promise<void> }
) => {
    const [polling, setPolling] = useState<boolean>(true);
    const { latest } = useCardTitleCsvImport(polling);

    useEffect(() => {
        if (!latest) {
            return;
        }

        if (
            polling &&
            (
                latest.status === CardTitleCsvImportStatus.Failed ||
                latest.status === CardTitleCsvImportStatus.Completed
            )) {
            setPolling(false);
            onCsvImportFinished(latest);
        } else if (
            !polling &&
            (
                latest.status === CardTitleCsvImportStatus.Accepted ||
                latest.status === CardTitleCsvImportStatus.Processing
            )) {
            setPolling(true);
        }
    }, [latest, polling, onCsvImportFinished]);

    if (!latest) {
        return null;
    }

    let icon = <LoadingOutlined style={{ color: "var(--dcs-bright-blue)" }} />;
    switch (latest.status) {
        case CardTitleCsvImportStatus.Unknown:
            icon = <WarningOutlined style={{ color: "var(--dcs-warning)" }} />;
            break;
        case CardTitleCsvImportStatus.Completed:
            icon = <CheckCircleOutlined style={{ color: "var(--dcs-dark-green)" }} />;
            break;
        case CardTitleCsvImportStatus.Failed:
            icon = <ExclamationCircleOutlined style={{ color: "var(--dcs-error-red)" }} />;
            break;
    }

    return <Space>
        {icon}
        <span>
            {latest.filename}: {CardTitleCsvImportStatusNames[latest.status]}
        </span>
        {latest.status === CardTitleCsvImportStatus.Completed && <span>
            ({latest.created} created, {latest.skipped} skipped)
        </span>}
    </Space>
}

export default CurrentCardTitleCsvImportStatus;